import React from "react";
import InbodySportAdviseDialog from "@icoach/inbody/dialog/InbodySportAdviseDialog";

/**
 * isShow 為後端決定是否要顯示出來點選開啟，請勿與前端Label是否顯示該欄位混為一談
 * ex:前端有顯示欄位，後端沒給此值就只是看到欄位不會有彈窗可以看到
 */
const InBodyInterviewSportAdviseDialog = props => {
	const { measureID, isShow } = props;

	if (!isShow) return null;

	return <InbodySportAdviseDialog sourceData={{ measureID }} />;
};

export default InBodyInterviewSportAdviseDialog;
